import React from "react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { pathwaySteps } from "../../data/content";
export function PathwaySection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-249" data-mp="2lw1zgaakcgzs">
      <div className="mx-auto max-w-3xl" data-id="element-250" data-mp="2lu8s0ss4lsqq">
        <SectionHeading tone="dark" eyebrow="The method" title={<>The 15-Minute Blepharoplasty <em className="text-gold-400" data-id="element-252" data-mp="3elsgos7hrz04">Case Pathway™</em></>} data-id="element-251" data-mp="2gy9yyrvurmjz" />
        <p className="mx-auto mt-6 max-w-xl text-center font-serif text-xl italic leading-snug text-white/90 sm:text-2xl" data-id="element-253" data-mp="3ej68cqcs1fgu">
          “Don’t start by looking for the answer. Start by learning how to look at the case.”
        </p>

        <div className="mt-10" data-id="element-254" data-mp="2zo8eft1zchxn">
          <div className="rounded-2xl bg-gold-500 px-5 py-3 text-center font-serif text-xl font-bold uppercase tracking-wider text-navy-900" data-id="element-255" data-mp="2zn6sgtjfeb15">The Case</div>
          <ol className="relative mt-3 space-y-3 border-l-2 border-gold-500/40 pl-6 ml-5" data-id="element-256" data-mp="1o8t9a1zmajrg">
            {pathwaySteps.map((step, i) => <li key={step.name} className="relative" data-id="element-257" data-mp="3ix6pf9ucbvbo" data-mpi={i}>
                <span className="absolute -left-[41px] top-4 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gold-500 bg-navy-900 text-sm font-bold text-gold-400" data-id="element-258" data-mp="3nv85dlwgzeix">
                  {i + 1}
                </span>
                <div className="rounded-2xl bg-navy-800 p-5" data-id="element-259" data-mp="3dw0ud5d7jvyz">
                  <h3 className="text-lg font-extrabold uppercase tracking-wide text-gold-400" data-id="element-260" data-mp="305nod8jvmrca">{step.name}</h3>
                  <ul className="mt-2 space-y-1" data-id="element-261" data-mp="34w426trm0ez6">
                    {step.prompts.map(pr => <li key={pr} className="text-base leading-relaxed text-white/85" data-id="element-262" data-mp="2q7pwmb2t6cex">{pr}</li>)}
                  </ul>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mt-10 text-center font-serif text-2xl font-bold text-white" data-id="element-263" data-mp="2h7uj3zls65bq">
          One case. One pathway. <span className="text-gold-400" data-id="element-264" data-mp="2l7bsv588pomp">Approximately 15 minutes.</span>
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-265" data-mp="rpxmbwgjox0p">
          <CTAButton label="I want to use the 15-minute pathway" data-id="element-266" data-mp="rrqx9ny6y3ei" />
        </div>
      </div>
    </section>;
}